module.exports = __webpack_public_path__ + "static/img/img_e.26f99720.png";